import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'

import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import * as ShortlistActions from '@disco/state-management/actions/ShortlistActions'
import { getPlaylist } from '@disco/state-management/selectors/playlists'
import { getPlaylistSharesWithContacts } from '@disco/state-management/selectors/shares'

import EditGroupForm from 'components/common/email-groups/edit-form'
import DocumentHeadTags from 'components/document-head-tags'

import type { RootState } from 'store/configureStore'

const mapStateToProps = (
  state: RootState,
  { playlistId }: { playlistId: string },
) => {
  return {
    playlist: getPlaylist(state, {
      id: parseInt(playlistId),
    }),
    shares: getPlaylistSharesWithContacts(state),
    user: state.user,
  }
}

const mapDispatchToProps = { ...ShortlistActions, sendMixpanelEvent }

const connector = connect(mapStateToProps, mapDispatchToProps)
type PlaylistShare = {
  recipients: Record<string, any>[]
}
type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
  params: {
    playlistId: string
    shareId: string
  }
  navigate: NavigateFunction
}

class CreateEmailGroup extends React.Component<Props> {
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const { playlist } = nextProps
    if (!playlist) this.props.navigate('/')
  }

  _closeGroupModal = () => {
    const { playlistId, shareId } = this.props.params
    const path = `/explorer/playlists/${playlistId}/shared/${shareId}`
    this.props.navigate(path)
  }
  _completeGroup = (groupName: string) => {
    this.props.sendMixpanelEvent('Create email group via share modal')
    const { playlistId, shareId } = this.props.params
    const path = `/explorer/playlists/${playlistId}/shared/${shareId}?emailGroup=${groupName}`
    this.props.navigate(path)
  }

  render() {
    const { shareId } = this.props.params
    const { playlist } = this.props
    if (!playlist) return null
    const recipients = this.props.shares[shareId].recipients.filter(
      r => r.type !== 'business',
    )
    return (
      <div>
        <DocumentHeadTags title="Edit email group | DISCO" />
        <EditGroupForm
          noRecipientEditing
          recipients={recipients}
          onClose={this._closeGroupModal}
          onSubmit={this._completeGroup}
        />
      </div>
    )
  }
}

const ConnectedCreateEmailGroup = connector(CreateEmailGroup)

export default function CreateEmailGroupWithNavigate(
  props: Partial<PropsFromRedux>,
) {
  const navigate = useNavigate()
  const { playlistId, shareId } =
    useParams<{ playlistId: string; shareId: string }>()
  return (
    <ConnectedCreateEmailGroup
      {...props}
      navigate={navigate}
      params={{ playlistId, shareId }}
      playlistId={playlistId}
    />
  )
}
